const carouselItems = [
  {
    id: 1,
    title: '暑期档·悬疑犯罪季',
    desc: '高智商对决、层层反转，六部年度犯罪大片联映，挑战你的推理极限',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20alleyway%20at%20night%20with%20warm%20amber%20street%20lamp%20light%20casting%20long%20shadows%2C%20detective%20silhouette%20in%20trench%20coat%2C%20film%20noir%20aesthetic%2C%20rich%20crimson%20and%20gold%20color%20palette%2C%20cinematic%20widescreen&width=1200&height=600&seq=carousel-01-beiwo&orientation=landscape',
    tag: '悬疑',
  },
  {
    id: 2,
    title: '科幻巨制·星际穿越特辑',
    desc: '从经典到新作，十部必看科幻电影带你探索宇宙的无限可能',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20spiral%20galaxy%20with%20bright%20golden%20core%20and%20cosmic%20dust%20lanes%2C%20starship%20silhouette%20crossing%20the%20frame%2C%20deep%20space%20background%20with%20nebula%20colors%20in%20amber%20and%20crimson%2C%20epic%20sci-fi%20cinematography&width=1200&height=600&seq=carousel-02-beiwo&orientation=landscape',
    tag: '科幻',
  },
  {
    id: 3,
    title: '国漫崛起·匠心之作合集',
    desc: '近年最佳国产动画电影精选，东方美学与顶尖制作的完美融合',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20ink%20wash%20painting%20style%20landscape%20with%20mountains%20and%20clouds%2C%20traditional%20pagoda%20silhouette%2C%20golden%20sunlight%20breaking%20through%20mist%2C%20elegant%20artistic%20composition%2C%20warm%20earthy%20tones%20with%20red%20accents&width=1200&height=600&seq=carousel-03-beiwo&orientation=landscape',
    tag: '动画',
  },
  {
    id: 4,
    title: '高分韩剧·年度精选',
    desc: '豆瓣8分以上韩剧特辑，从浪漫爱情到社会写实，部部精品',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Seoul%20cityscape%20at%20sunset%20with%20warm%20golden%20light%20reflecting%20on%20modern%20buildings%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20dreamy%20atmosphere%2C%20Korean%20drama%20aesthetic%2C%20cinematic%20wide%20shot&width=1200&height=600&seq=carousel-04-beiwo&orientation=landscape',
    tag: '韩剧',
  },
  {
    id: 5,
    title: '经典重温·豆瓣TOP250',
    desc: '那些年我们追过的经典，跨越时代的电影佳作一次收藏',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20cinema%20theater%20interior%20with%20red%20velvet%20seats%20and%20gold%20decorative%20details%2C%20old%20film%20projector%20with%20warm%20glowing%20light%20beam%2C%20nostalgic%20atmosphere%2C%20classic%20Hollywood%20glamour%2C%20rich%20amber%20tones&width=1200&height=600&seq=carousel-05-beiwo&orientation=landscape',
    tag: '经典',
  },
  {
    id: 6,
    title: '纪录片·看见真实世界',
    desc: '自然、人文、历史类高分纪录片精选，用镜头讲述动人故事',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20of%20golden%20hour%20over%20vast%20grasslands%20with%20distant%20mountains%2C%20warm%20sunlight%20streaming%20through%20clouds%2C%20wildlife%20silhouette%2C%20documentary%20photography%20style%2C%20rich%20earthy%20amber%20tones&width=1200&height=600&seq=carousel-06-beiwo&orientation=landscape',
    tag: '纪录',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-accent-600 tracking-widest uppercase mb-2">Featured</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            精选影视专题合集，帮你发现更多值得看的好内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-xl overflow-hidden aspect-[16/10] cursor-pointer bg-background-100"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <span className="absolute top-4 left-4 px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                {item.tag}
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-lg font-semibold text-white mb-1.5" style={{ fontFamily: 'var(--font-heading)' }}>
                  {item.title}
                </h3>
                <p className="text-sm text-white/70 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}